





























import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from '../components/Button.vue';
import Api from '../utils/Api';

@Component({
	components: {
		Button
	}
})
export default class Home extends Vue {

	public name:string = "";
	public room:string = "";
	public loading:boolean = false;

	public get canSubmit():boolean {
		return this.room && this.room.length >= 3 && this.name && this.name.length >= 3;
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public async onSubmitForm():Promise<void> {
		if(!this.canSubmit) return;
		
		this.loading = true;
		try {
			let res = await Api.post("room/join", {name:this.name, room:this.room});
			this.$store.dispatch("joinRoom", {room:res.room, me:res.me});
			this.$router.push({name:"play"});
		}catch(error) {
			this.$store.state.alert = error.message;
		}
		this.loading = false;
	}

}
